// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"727cbe63","787":"fcb00d57"}[chunkId] + ".chunk.js";
};